import { render } from "./ProxyConfigList.vue?vue&type=template&id=895d59b4&scoped=true"
import script from "./ProxyConfigList.vue?vue&type=script&lang=js"
export * from "./ProxyConfigList.vue?vue&type=script&lang=js"

import "./ProxyConfigList.vue?vue&type=style&index=0&id=895d59b4&scoped=true&lang=scss"

import exportComponent from "D:\\由创科技-ljx\\apicode\\github\\DY.Web\\TikTokWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-895d59b4"]])

export default __exports__